<template>
    <div class="post">
        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notification is-light">
            <b>{{ error }}</b>
        </div>
        <h1 class="title is-4 py-4" id="read">Actualités</h1>
        <div v-for="(post, index) in posts" v-bind:key="post._id" class="box blogpost">
            <nav class="levelx">
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading"><span title="publié le" class="has-text-grey">
                                <b-icon icon="clock-outline">
                                </b-icon> {{post.datepost | formatDate}}
                            </span></p>
                        <h2 v-cloak v-bind:title="index" class="title is-5 pb-2">{{ post.title | capitalize }}</h2>
                    </div>
                </div>
            </nav>
            <img alt="img" v-if="post.image" :src="post.image.path" width="280" @error="imageUrlAlt">
            <template v-if="post.excerpt">
                <p v-html="post.excerpt"></p>
                <div class="has-text-centered py-4"><router-link class="button bounce-out-on-hover is-danger is-normal" :to="'/post/'+ post._id+'#read'">Voir plus...</router-link></div>
            </template>
            <template v-else>
                <p v-html="post.content"></p>
                <div class="has-text-centered">
                    <social-sharing v-bind:url="curr_path+'/post/'+ post._id" v-bind:hashtags="hashtag" v-bind:title="post.title+' 👉 '" inline-template>
                        <div>
                            <network network="facebook">
                                <b-icon icon="facebook"></b-icon>
                            </network><span style="visibility: hidden;">|||</span>
                            <network network="twitter">
                                <b-icon icon="twitter"></b-icon>
                            </network>
                        </div>
                    </social-sharing>
                </div>
            </template>
        </div>
        <nav v-if="posts" class="pagination" role="navigation" aria-label="pagination">
            <ul class="pagination-list">
                <li>
                    <a :disabled="indexpage<2" class="pagination-link" aria-label="prev" @click="indexpage--">
                        &lt;</a> </li>
                <li v-for="page in totalpages" v-bind:key="page">
                    <a v-bind:class="[page == indexpage ? 'is-current' : '', 'pagination-link']" :aria-label="'Page ' + page" aria-current="page" @click="indexpage = page">{{page}}</a>
                </li>
                <li>
                    <a :disabled="indexpage>totalpages-1" class="pagination-link" aria-label="next" @click="indexpage++">&gt;</a>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
const axios = require('axios');
var SocialSharing = require('vue-social-sharing');
export default {
    data: function() {
        return {
            loading: true,
            posts: null,
            error: null,
            indexpage: 1,
            limitperpage: 3,
            totalposts: null,
            totalpages: 1,
            curr_path: window.location.origin,
            hashtag: this.$share_hashtag,
        }
    },
    components: {
        SocialSharing
    },
    name: 'Posts',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData',
        indexpage(numpage) { this.getPagePosts(numpage) }
    },
    methods: {
        imageUrlAlt(event) {
            event.target.src = "https://buefy.org/static/img/placeholder-1280x960.png"
        },
        fetchData() {
            this.error = this.posts = null
            this.loading = true
            var vm = this
            //var fetchurl = this.$api_url_posts
            var fetchurl = this.$api_url_posts+'&sort[datepost]=-1'
            axios({
                    method: 'get',
                    url: fetchurl,
                    /*headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        sort: { datepost: -1 },
                    })*/
                })
                .then(function(response) {
                    vm.loading = false
                    vm.totalposts = response.data.total
                    vm.totalpages = Math.ceil(vm.totalposts / vm.limitperpage)
                    vm.posts = response.data.entries.slice(0, vm.limitperpage)
                })
                .catch(function() {
                    vm.error = 'erreur'
                })
        },
        getPagePosts: function(numpage) {
            var vm = this
            numpage = (numpage < 1) ? 1 : ((numpage > vm.totalpages) ? vm.totalpages : numpage)
            this.indexpage = numpage

            var fetchurl = this.$api_url_posts
            axios({
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        limit: vm.limitperpage,
                        skip: (vm.limitperpage) * (numpage - 1),
                        sort: { datepost: -1 },
                    })
                }).then(function(response) {
                    vm.totalposts = response.data.total
                    vm.totalpages = Math.ceil(vm.totalposts / vm.limitperpage)
                    vm.posts = response.data.entries
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                }).then(function() {
                    window.scrollTo(0, 0)
                })

        },

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.blogpost {
    border-left: 0px solid red;
    margin-bottom: 40px;
    border-radius: 0px;
    box-shadow: 1px 1px 12px #555;
    background: #fafafa;

}

a {
    color: #42b983;
}

.pagination-link.is-current {
    background-color: #ff3860;
    border-color: #ff3860;
    color: white;
}


.bounce-out-on-hover {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
}
.bounce-out-on-hover:hover, .bounce-out-on-hover:focus, .bounce-out-on-hover:active {
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
  -webkit-transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);
  transition-timing-function: cubic-bezier(0.47, 2.02, 0.31, -0.36);
}

h2{
   word-break: break-word;
}
</style>